var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', [_vm.show ? _c('div', {
    staticClass: "modal-overlay"
  }, [_c('ValidationObserver', {
    attrs: {
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('div', {
          class: [_vm.classes]
        }, [!_vm.hideHeader ? _c('div', {
          staticClass: "modal-heading"
        }, [_vm._t("title", function () {
          return [_c('h3', {
            staticClass: "modal-title text-center uppercase"
          }, [_vm._v(_vm._s(_vm.title))])];
        }), !_vm.hideClose ? _c('a', {
          staticClass: "btn-close bg-white w-5 h-5 flex justify-center items-center rounded-full absolute top-1 right-1",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.onClose.apply(null, arguments);
            }
          }
        }, [_c('i', {
          staticClass: "fa-solid fa-xmark text-red-500"
        })]) : _vm._e()], 2) : _vm._e(), _c('div', {
          staticClass: "modal-body pt-4 overflow-y-auto h-auto max-h-[80vh] md:max-h-[70vh]",
          class: _vm.bodyClass
        }, [_vm._t("default", null, {
          "handleSubmit": handleSubmit
        })], 2), !_vm.hideFooter ? _c('div', {
          staticClass: "modal-footer mt-5"
        }, [_vm._t("footer", function () {
          return [_c('div', {
            staticClass: "text-center space-x-2"
          }, [!_vm.hideOk ? _c('Button', {
            staticClass: "min-w-20",
            attrs: {
              "is-loading": _vm.loading,
              "size": "md",
              "variant": "primary"
            },
            on: {
              "click": function ($event) {
                return handleSubmit(_vm.onOk);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm.okText || _vm.$t("OK")) + " ")]) : _vm._e(), _c('Button', {
            staticClass: "min-w-20",
            attrs: {
              "size": "md",
              "variant": "white"
            },
            on: {
              "click": _vm.onClose
            }
          }, [_vm._v(_vm._s(_vm.closeText || _vm.$t("Close")) + " ")])], 1)];
        })], 2) : _vm._e()])];
      }
    }], null, true)
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }